export enum SPINNER_EUMS {
    APP_SPINNER = 'app-spinner',
    UNDISPLAY = 'undisplayed',
}
